import React from "react";
import Auth from "./auth";
import {FormControl, Button } from "react-bootstrap";

function NewPasswordLayout(props) {
  const termsUrl = "https://www.finpay.net/finpay-website-user-agreement/";


  function toggleShowPassword(e) {
    if(e.target.className.indexOf("glyphicon-eye-open") >= 0) {
        e.target.className = "glyphicon glyphicon-eye-close";
        e.target.parentNode.childNodes[0].type = "text";
    } else {
        e.target.className = "glyphicon glyphicon-eye-open";
        e.target.parentNode.childNodes[0].type = "password";
    }
  }

  return (
    <Auth title="Welcome to Finpay!">
      <h4>Create your Finpay password</h4>
      <form
        onSubmit={props.handleSubmit}
        className="new-password-form clearfix"
      >
        <div className="form-group password-field">
          <FormControl
            type="password"
            placeholder="Password"
            name="password"
            required
          />
            <i className="glyphicon glyphicon-eye-open" onClick={toggleShowPassword}></i>
        </div>
          <div className="form-group password-field">
            <FormControl
                type="password"
                placeholder="Password Confirmation"
                name="password_confirmation"
                required
            />
              <i className="glyphicon glyphicon glyphicon-eye-open" onClick={toggleShowPassword}></i>
        </div>

        <div className="terms-link">
          <input className="pull-left check-terms" type="checkbox" required />
          <span>I agree to the </span>
          <a target="_blank" href={termsUrl}>
            <b>Terms and Conditions</b>
          </a>
        </div>

        <div className="buttons text-center">
          <Button type="submit">Set Password</Button>
          <Button onClick={props.handleCancel}>Cancel</Button>
        </div>
      </form>
    </Auth>
  );
}

export default NewPasswordLayout;



// WEBPACK FOOTER //
// ./src/auth/components/new-password-layout.js